// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__3LOmQ","load1":"Spinner_load1__3CPR6"};